export const company = [
    {data : 'Coop',},
    {data : 'Bareburger',},
    
]

export const priority = [
    {data : 'Low - 1 week'},
    {data : 'Meduim - 3 Days'},
    {data : 'Hight -  1 Day'},
    {data : 'Urgent'},
]

export const user = [
    {data : 'Manoj'},
    {data : 'Vishal'},
    {data : 'Satish'},
]

export const status = [
    {data : 'To be Schedule'},
    {data : 'Under Investigation'},
    {data : 'LPO Approval'},
    {data : 'On Hold'},
    {data : 'Closed'},
]
